export default __webpack_public_path__ + "static/media/Bossonian Bascinet.275afcad.jpg";